import { Analytic } from "./AnalysisDetails";
import { TimeBasedVisualizationConfig, TimeBasedVisualizationConfigJSON } from "./TimeBasedVisualizationConfig";

export type MAPOptPlotJSON = TimeBasedVisualizationConfigJSON & {
	abpModality: string
	stO2Left: string
	stO2Right: string
	coxThreshold: number
	enableLeft: boolean
	enableRight: boolean
	mapoptAlgorithm: Analytic.MAPOpt | Analytic.MAPOpt_FLEX
}

export type MAPOptPlotConfig = TimeBasedVisualizationConfig & {
	abpModality: string
	stO2Left: string
	stO2Right: string
	coxThreshold: number
	enableLeft: boolean
	enableRight: boolean
	mapoptAlgorithm: Analytic.MAPOpt | Analytic.MAPOpt_FLEX
}

export const DEFAULT_MAPOPT_PLOT_JSON: MAPOptPlotJSON = {
	abpModality: "ABP_na",
	stO2Left: "StO2_1_Left_Brain",
	stO2Right: "StO2_2_Right_Brain",
	enableLeft: true,
	enableRight: true,
	viewDuration: 4 * 60 * 60 * 1000,
	coxThreshold: 0.3,
	playbackSpeed: 1,
	mapoptAlgorithm: Analytic.MAPOpt
}

export type MAPOptData = {
	MAPOpt: number | null
	LLA: number | null
	ULA: number | null
	fitType: number | null
	fitSpan: number | null
	includedDataPercentage: number | null
	coefficients: (number | null)[]
	yValues: (number | null)[]
	errors: (number | null)[]
	dataPercentages: (number | null)[]
	includedInFit: (number | null)[]
	weight: number | null
	startTime: Date | null
	endTime: Date | null
}
